import axios from 'axios'

export default class Beneficiario {
  constructor (tokenBearer, url, id) {
    this.url = `${url}/api/unimed/compBeneficiario/${id}`
    this.urlUltimo = `${url}/api/unimed/compBeneficiario/ultima/${id}`
    this.urlPendetes = `${url}/api/unimed/compBeneficiario/pendentes/${id}`
    this.tokenBearer = tokenBearer
  }

  async getBeneficiarios (args) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getUltimoBeneficiario () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.urlUltimo,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getPendentesBeneficiarios () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.urlPendetes,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async putBeneficiario (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
